import type { DividerDesignTokens, DividerTokenSections } from '@openng/optimus-ui-themes/types/divider';

export const horizontal: DividerTokenSections.Horizontal = {
	padding: '0',
};

export const vertical: DividerTokenSections.Vertical = {
	padding: '0',
};

export default {
	horizontal,
	vertical,
} satisfies DividerDesignTokens;
